import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./adminsSummary.css";
import PrettyContainer from "../../prettyContainer/PrettyContainer";
import { Alert, Badge, Spinner } from "react-bootstrap";
import { getAdminsSummary } from "../../../helpers/api";
import moment from "moment";
const configSystem = require("../../../configApp");

// Como se llama cada rol en la pantalla.
const ROL = {
  [configSystem.roles.SUPER_ADMIN]: { label: "Super Admin", variant: "dark" },
  [configSystem.roles.SUPER_USER]: { label: "Super User", variant: "primary" },
  [configSystem.roles.ADMIN]: { label: "Admin", variant: "info" },
  [configSystem.roles.BASIC_CUSTOMER]: { label: "Customer", variant: "secondary" },
};

export default function AdminsSummaryPage() {
  const navigate = useNavigate();

  const [admins, setAdmins] = useState([]);
  const [generado, setGenerado] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const cargar = () => {
    setIsLoading(true);
    setError("");
    getAdminsSummary()
      .then((datos) => {
        setAdmins(datos.admins || []);
        setGenerado(datos.generado || null);
        setIsLoading(false);
      })
      .catch((e) => {
        setError(typeof e === "string" ? e : "Could not load the summary");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Totales de la ultima fila: la suma de lo que se esta viendo.
  const totales = admins.reduce(
    (acc, a) => ({
      total: acc.total + a.total,
      activos: acc.activos + a.activos,
      porVencimiento: acc.porVencimiento + a.porVencimiento,
      porCascada: acc.porCascada + a.porCascada,
      aMano: acc.aMano + a.aMano,
      altas30: acc.altas30 + a.altas30,
      altas15: acc.altas15 + a.altas15,
    }),
    { total: 0, activos: 0, porVencimiento: 0, porCascada: 0, aMano: 0, altas30: 0, altas15: 0 }
  );

  // Un cero no dice nada y ensucia la tabla; se deja en gris.
  const num = (n) => (n > 0 ? n : <span className="ig-adminsSummary-cero">0</span>);

  return (
    <PrettyContainer tittle="Admins">
      <div className="ig-adminsSummary-wrapper">
        {error !== "" && <Alert variant="warning">{error}</Alert>}

        {isLoading ? (
          <div className="ig-adminsSummary-loading">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <div className="ig-adminsSummary-note">
              Los usuarios de cada administrador son los que esa cuenta dio de alta.
              Las altas se cuentan por fecha de creacion.
              {generado && ` · Actualizado ${moment(generado).format("YYYY-MM-DD HH:mm")}`}
            </div>

            <div className="ig-adminsSummary-scroll">
              <table className="ig-adminsSummary-table">
                <thead>
                  <tr>
                    <th rowSpan={2}>Admin</th>
                    <th rowSpan={2}>Role</th>
                    <th rowSpan={2}>Users</th>
                    <th rowSpan={2}>Active</th>
                    <th colSpan={3}>Disabled — why</th>
                    <th colSpan={2}>New sign-ups</th>
                  </tr>
                  <tr>
                    <th className="ig-adminsSummary-sub">Due date</th>
                    <th className="ig-adminsSummary-sub">Admin block</th>
                    <th className="ig-adminsSummary-sub">By hand</th>
                    <th className="ig-adminsSummary-sub">30 days</th>
                    <th className="ig-adminsSummary-sub">15 days</th>
                  </tr>
                </thead>

                <tbody>
                  {admins.length === 0 && (
                    <tr>
                      <td colSpan={9} className="ig-adminsSummary-vacio">
                        No admins have created users yet.
                      </td>
                    </tr>
                  )}

                  {admins.map((a) => {
                    const rol = ROL[a.type] || { label: `Type ${a.type}`, variant: "light" };
                    return (
                      <tr key={a.adminId}>
                        <td>
                          <span
                            className="ig-adminsSummary-nombre"
                            title="See this admin's users"
                            onClick={() =>
                              navigate(`/user-management?createdBy=${a.adminId}`)
                            }
                          >
                            {a.username}
                          </span>
                          {!a.adminEnabled && (
                            <Badge bg="danger" className="ig-adminsSummary-apagado">
                              blocked
                            </Badge>
                          )}
                        </td>
                        <td>
                          <Badge bg={rol.variant}>{rol.label}</Badge>
                        </td>
                        <td className="ig-adminsSummary-fuerte">{a.total}</td>
                        <td className="ig-adminsSummary-ok">{num(a.activos)}</td>
                        <td>{num(a.porVencimiento)}</td>
                        <td className={a.porCascada > 0 ? "ig-adminsSummary-cascada" : ""}>
                          {num(a.porCascada)}
                        </td>
                        <td>{num(a.aMano)}</td>
                        <td className="ig-adminsSummary-fuerte">{num(a.altas30)}</td>
                        <td className="ig-adminsSummary-fuerte">{num(a.altas15)}</td>
                      </tr>
                    );
                  })}
                </tbody>

                {admins.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan={2}>Total</td>
                      <td>{totales.total}</td>
                      <td className="ig-adminsSummary-ok">{totales.activos}</td>
                      <td>{totales.porVencimiento}</td>
                      <td>{totales.porCascada}</td>
                      <td>{totales.aMano}</td>
                      <td>{totales.altas30}</td>
                      <td>{totales.altas15}</td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </>
        )}
      </div>
    </PrettyContainer>
  );
}
